import * as axios from '../../helpers/axios'

export const getInstallationsByCustomer = (selectedCustomer) => {
    const customerCode = selectedCustomer.customer_code
    return axios.runGet(
        'auth/services/webcontrol?selectedCustomer=' +
            customerCode
    )
}
